// extracted by mini-css-extract-plugin
export default {"container":"PageContainer_container__PbdPR","header":"PageContainer_header__rKhwa","content-container":"PageContainer_content-container__WBkOf"};